import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import Configs from '../constants/configs';
import {ParamsBuilder} from '../models/ParamsBuilder';
import {BaseApiService} from './base-api.service';

@Injectable()
export class FileDownloadApiService extends BaseApiService {

  fileDownload(url: string, fileType: string, params?: any): Observable<any> {
    const builder = new ParamsBuilder();
    builder.limit = Configs.pagination.listAll;
    Object.keys(params).forEach(key => {
      builder.setParam(key, params[key]);
    });

    // add full url if start with /
    if (url.charAt(0) === '/') {
      url = `${this.baseUrl}/${url}`;
    }

    url += url.indexOf('?') >= 0 ? '&' : '?';
    url += 'output=' + fileType;

    return this.http.get(url, {params: builder.build()});
  }
}
